import { Token } from '@kb3d/models/classes/token';
import { MirrorGeometryProcessor } from './geometry-processor/mirror-geometry';
import { SliceFeatureRenderer } from './slice';

export class MirrorFeatureRenderer extends SliceFeatureRenderer {
    modelToken = Token.MirrorFeature;
    processor = new MirrorGeometryProcessor(this.scene);
}
